module.exports = __webpack_public_path__ + "static/media/edit_filled.6f29a205.svg";